var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0406 0H17.9586C8.04305 0 0.00488281 8.04052 0.00488281 17.959V18.041C0.00488281 27.9595 8.04305 36 17.9586 36H18.0406C27.9561 36 35.9943 27.9595 35.9943 18.041V17.959C35.9943 8.04052 27.9561 0 18.0406 0Z",
    fill: "#007EBB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58779 11.9666C8.1137 11.5264 7.87793 10.9816 7.87793 10.3333C7.87793 9.68502 8.11496 9.11619 8.58779 8.67475C9.06188 8.23457 9.67216 8.01385 10.4199 8.01385C11.1676 8.01385 11.7539 8.23457 12.2267 8.67475C12.7008 9.11493 12.9366 9.66862 12.9366 10.3333C12.9366 10.998 12.6995 11.5264 12.2267 11.9666C11.7526 12.4068 11.1512 12.6275 10.4199 12.6275C9.68855 12.6275 9.06188 12.4068 8.58779 11.9666ZM12.5381 14.4917V27.9871H8.2751V14.4917H12.5381Z",
    fill: "#FEFFFC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7288 15.8249C27.6581 16.8339 28.1221 18.2188 28.1221 19.982V27.7488H24.0734V20.5294C24.0734 19.6402 23.8427 18.949 23.3825 18.4571C22.9223 17.9653 22.3019 17.718 21.5252 17.718C20.7485 17.718 20.1281 17.964 19.6679 18.4571C19.2077 18.949 18.9769 19.6402 18.9769 20.5294V27.7488H14.9043V14.4539H18.9769V16.2172C19.3892 15.6294 19.9453 15.1653 20.6438 14.8235C21.3424 14.4817 22.1279 14.3114 23.0017 14.3114C24.5576 14.3114 25.8008 14.8159 26.7288 15.8249Z",
    fill: "#FEFFFC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.651296606680184dc468582f62d963fc.svg";
export { ForwardRef as ReactComponent };